import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import DataTable from '../../components/Table/DataTable';
import SearchBox from './../../components/SearchBox/SearchBox';

import { getLoopsData } from '../../services/loop';
import { showAlert } from '../../store/ducks/alert';

import { CircularProgress } from '@material-ui/core';

const LoopLinks = ({ channelId = null, location, match }) => {
  const dispatch = useDispatch();
  const [loops, setLoops] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [isOrdering, setIsOrdering] = useState(0);
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });
  const [orderDirections, setOrderDirections] = useState({
    item: '',
    direction: '',
  });

  useEffect(() => {
    if (location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
    }
  }, [location]);

  useEffect(() => {
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    displayLoops();
  }, [isSearching, isOrdering, page]);

  const handleSubmitSearch = searchBox => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const displayLoops = async () => {
    try {
      setIsLoading(true);

      let params = { order: orderDirections.item, direction: orderDirections.direction, limit: 5 };
      if (isSearching) params = { ...searchField, ...params };

      const { data: loops } = await getLoopsData(page, params);

      setLoops(loops.rows);
      setTotalItems(loops.count);
      setTotalPages(loops.pages);
      setPage(loops.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  const headers = ['channelId', 'enabled', 'label', 'createdAt'];

  const SearchBoxHeaders = ['id', 'channelId', 'type', 'label', 'url'];

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="issues-container">
        <h1>Loop Links ({totalItems})</h1>

        {!channelId && (
          <SearchBox
            selectItems={SearchBoxHeaders}
            onSubmitSearch={handleSubmitSearch}
            isSearching={isSearching}
            setIsOrdering={setIsOrdering}
          />
        )}
      </div>

      <DataTable
        head={headers}
        body={loops}
        bodyColumn={headers}
        action={true}
        linkPath={'loops'}
        totalPages={totalPages}
        currentPage={page}
        setPageChange={setPage}
        orderDirections={orderDirections}
        setOrderDirections={setOrderDirections}
        setIsOrdering={setIsOrdering}
        isOrdering={isOrdering}
      />
    </>
  );
};

export default LoopLinks;
